module.exports = '<svg width="27" height="32" viewBox="0 0 27 32"><path d="M17.54 32H9.173c-.772 0-1.159-.606-1.159-1.357v-12H.804c-.772 0-1.034-.625-.585-1.242L12.545.475c.449-.612 1.173-.644 1.621-.035l12.326 16.979c.449.612.187 1.221-.585 1.221H18.7v12c0 .753-.387 1.36-1.159 1.36z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-arrow-1.js
// module id = 1471
// module chunks = 14